module.exports = __webpack_public_path__ + "img/2024-02-13f_1.95ed161a.png";